export const getContactAddressLine = (contactInfoAddressData) => {
    const { address, postalcode, city } = contactInfoAddressData;
    let addressLine = '';

    if (address) {
        addressLine += address;
        if (postalcode || city) {
            addressLine += ', ';
        }
    }

    if (postalcode && city) {
        addressLine += `${postalcode} ${city}`;
    } else if (postalcode && !city) {
        addressLine += postalcode;
    } else if (!postalcode && city) {
        addressLine += city;
    }

    return addressLine;
};
